// Talkani Logo — geometric "T" with motion arrow (logistics) and sparkle dot (cleaning)
// Variants: "mark" (icon only), "light" (for dark backgrounds), "dark" (for light backgrounds)

export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Talkani Logo"
    >
      {/* Background — square with notched top-right corner suggesting motion */}
      <path
        d="M0 4 C0 1.79 1.79 0 4 0 L36 0 L48 12 L48 44 C48 46.21 46.21 48 44 48 L4 48 C1.79 48 0 46.21 0 44 Z"
        fill="#FF5A00"
      />
      {/* Diagonal motion line at the notched corner */}
      <path
        d="M36 0 L48 12"
        stroke="#090A0B"
        strokeWidth="1.5"
        strokeLinecap="square"
        opacity="0.18"
      />
      {/* Bold T - horizontal bar */}
      <rect x="11" y="14" width="26" height="6" fill="#FFFFFF" />
      {/* Bold T - vertical stem */}
      <rect x="20.5" y="14" width="7" height="22" fill="#FFFFFF" />
      {/* Arrow integrated at the bottom of the T stem — suggests forward delivery motion */}
      <path
        d="M14.5 36 L20.5 30 L20.5 36 Z"
        fill="#FFFFFF"
        opacity="0.85"
      />
      {/* Sparkle dot at top-left — subtle hint at cleaning/freshness */}
      <circle cx="6" cy="6" r="1.6" fill="#FFFFFF" />
    </svg>
  );
}

export function LogoWordmark({ subtitle = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={36} />
      <div className="flex flex-col leading-none">
        <span className="font-black tracking-tight text-base sm:text-lg text-current">
          TALKANI<span className="text-[#FF5A00]">.</span>
        </span>
        {subtitle && (
          <span className="text-[10px] font-semibold tracking-widest uppercase text-neutral-500 mt-0.5">
            Logistik · Reinigung · Service
          </span>
        )}
      </div>
    </div>
  );
}
